import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { sendAdditionalForm } from 'shared/thunks';
import { sendForm } from 'shared/thunks/modalForm';
import { TFormStatus, EStatus, TSteps, TFormResponse } from 'shared/types/form';

const initialState: TFormStatus = {
  status: EStatus.Initial,
  step: 0,
  formFields: {
    address: '',
    phone: '',
  },
  priceRange: [0, 0],
};

const formSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(sendForm.pending, state => {
        state.status = EStatus.Loading;
      })
      .addCase(sendForm.fulfilled, (state, payload: PayloadAction<TFormResponse>) => {
        state.status = EStatus.Succeed;
        state.leadId = payload.payload.leadId;
      })
      .addCase(sendForm.rejected, state => {
        state.status = EStatus.Failed;
      });
    builder
      .addCase(sendAdditionalForm.pending, state => {
        state.status = EStatus.Loading;
      })
      .addCase(sendAdditionalForm.fulfilled, state => {
        state.status = EStatus.Succeed;
      })
      .addCase(sendAdditionalForm.rejected, state => {
        state.status = EStatus.Failed;
      });
  },
  initialState,
  name: 'formStatus',
  reducers: {
    setStatus: (state, action: PayloadAction<EStatus>) => {
      state.status = action.payload;
    },
    setStep: (state, action: PayloadAction<TSteps>) => {
      state.step = action.payload;
    },
    setPhone: (state, action: PayloadAction<string>) => {
      state.formFields.phone = action.payload;
    },
    setAddress: (state, action: PayloadAction<string>) => {
      state.formFields.address = action.payload;
    },
    setPriceRange: (state, action: PayloadAction<[number, number]>) => {
      state.priceRange = action.payload;
    },
  },
});

export const {
  reducer: formReducer,
  actions: { setStatus, setStep, setAddress, setPhone, setPriceRange },
} = formSlice;
